import { PaStatus, PaStatusLabels } from "../../../../enums/paStatus";

export const allPaStatusOptions = [
  { label: PaStatusLabels[PaStatus.APPROVED], value: PaStatus.APPROVED },
  { label: PaStatusLabels[PaStatus.DENIED], value: PaStatus.DENIED },
  {
    label: PaStatusLabels[PaStatus.PENDING],
    value: PaStatus.PENDING,
  },
  {
    label: PaStatusLabels[PaStatus.APPEAL_PENDING],
    value: PaStatus.APPEAL_PENDING,
  },
  {
    label: PaStatusLabels[PaStatus.AUTH_NOT_REQUIRED],
    value: PaStatus.AUTH_NOT_REQUIRED,
  },
  {
    label: PaStatusLabels[PaStatus.ONSHORE_ASSISTANCE],
    value: PaStatus.ONSHORE_ASSISTANCE,
  },
  { label: PaStatusLabels[PaStatus.NA_OUTCOME], value: PaStatus.NA_OUTCOME },
];
